import { render, staticRenderFns } from "./IconBackward.vue?vue&type=template&id=493914d1&scoped=true"
import script from "./IconBackward.vue?vue&type=script&lang=js"
export * from "./IconBackward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493914d1",
  null
  
)

export default component.exports